import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useDirectoryUnlockProductionCalendarByIdMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useDirectoryUnlockProductionCalendar = () => {
  const [handle, { loading, error: apolloError }] =
    useDirectoryUnlockProductionCalendarByIdMutation();

  const error = useError(apolloError);

  return {
    loading,
    error,
    unlock: useCallback(
      async (id: string) => {
        await handle({ variables: { id } });
      },
      [handle]
    ),
  };
};
